import axios from "axios";
// import Swal from "sweetalert2";
import {
  REQUEST_DATA_FROM_DIRECTORIES,
  SUCCESS_DATA_FROM_DIRECTORIES,
  GET_ERRORS,
  // SET_DISTRICT,
  SUCCESS_SET_DISTRICT,
  REQUEST_SET_DISTRICT,
  SET_STREET,
  // SET_CITY,
  SUCCESS_SET_CITY,
  REQUEST_SET_CITY,
  SET_INDEX,
  SUCCESS_SET_DISTRICT_FACT,
  REQUEST_SET_DISTRICT_FACT,
  SET_STREET_FACT,
  SUCCESS_SET_CITY_FACT,
  REQUEST_SET_CITY_FACT,
  SET_INDEX_FACT,
  SET_BANKS,
  CLEAR_INDEX_AND_DISTRICT,
  CLEAR_CITY_STREET_BANKS,
  CLEAR_CITY_STREET_BANKS_FACT,
  CLEAR_INDEX_AND_DISTRICT_FACT,
  APPLICANT_ADDRESS_CLEAR_FACT_REGION
} from "./types";

import {
  getAddresType,
  getCitizenShip,
  getDocumentType,
  getGender,
  getRegion,
  getRelation,
  getStreet,
  getDistrict,
  getCity,
  getIndex,
  getSubmitterType,
  getIndivent,
  getLegalActivity,
  getFreqPayment,
  getBanks,
  getReasonsRefusal,
  getCancel
} from "../../api/api.js";

import * as api from '../../api/api'

// const Toast = Swal.mixin({
//   toast: true,
//   position: "top-center",
//   showConfirmButton: false,
//   timer: 10000,
//   customClass: {
//     title: "title-class"
//   }
// });

function requestDataFromDirectories() {
  return {
    type: REQUEST_DATA_FROM_DIRECTORIES
  };
}

export function receiveDataFromDirectories(data) {
  return {
    type: SUCCESS_DATA_FROM_DIRECTORIES,
    payload: data
  };
}

export function requestDataforSelectStatement() {
  return function(dispatch) {
    dispatch(requestDataFromDirectories());
    axios
      .all([
        // getAddresType(),
        api.getDictionary('R_ADDRESSTYPE'),
        // getCitizenShip(),
        api.getDictionary('R_CITIZENSHIP'),
        // getDocumentType(),
        api.getDictionary('R_DOCUMENTTYPE'),
        // getGender(),
        api.getDictionary('R_GENDER'),
        // getRegion(),
        api.getDictionary('R_REGION'),
        // getRelation(),
        api.getDictionary('R_RELATION'),
        // getSubmitterType(),
        api.getDictionary('R_SUBMITTERTYPE'),
        // getIndivent(),
        // getLegalActivity(),
        // getReasonsRefusal(),
        // getCancel(),
        // getFreqPayment()
      ])
      .then(
        axios.spread(function(
          addressType,
          citizenShip,
          documentType,
          gender,
          region,
          relation,
          submitterType,
          // indivent,
          // legalActivity,
          // reasons,
          // cancels,
          // freqPayment
        ) {
          // let reasonsRefusal = reasons.data.map(item => ({
          //   value: item.value,
          //   label: item.label
          // }));

          // let cancelations = cancels.data.map(item => ({
          //   value: item.value,
          //   label: item.label
          // }));
          //console.log('addressType', addressType)
          const data = {
            addressType: addressType.data,
            citizenShip: citizenShip.data,
            documentType: documentType.data.sort((a, b) => a.value - b.value),
            gender: gender.data,
            region: region.data,
            relation: relation.data,
            submitterType: submitterType.data,
            // indivent: indivent.data,
            // legalActivity: legalActivity.data,
            // freqPayment: freqPayment.data,
            // reasonsRefusal: reasonsRefusal,
            // cancels: cancelations
          };
          dispatch(receiveDataFromDirectories(data));
          localStorage.setItem("catalog", JSON.stringify(data));
        })
      )
      .catch(err => {
        dispatch({
          type: GET_ERRORS,
          payload: err
        });
        // Toast.fire({
        //   title: "Помилка сервера.",
        //   type: "error"
        // });
      });
  };
}

//retrieving data through a query chain
//region->district-> street et.c

function receiveBanks(banks) {
  return {
    type: SET_BANKS,
    payload: banks.data
  };
}

// function requestDistrict(){
//   return {type: REQUEST_SET_DISTRICT}
// }

function receiveDistrict_fact(district) {
  return {
    type: SUCCESS_SET_DISTRICT_FACT,
    district_fact: district.data
  };
}

function receiveStreet_fact(street) {
  return {
    type: SET_STREET_FACT,
    street_fact: street.data
  };
}

function receiveCity_fact(city) {
  return {
    type: SUCCESS_SET_CITY_FACT,
    city_fact: city.data
  };
}

function receiveIndex_fact(index) {
  return {
    type: SET_INDEX_FACT,
    index_fact: index.data
  };
}

export const requestDataDirectories = (name, id) => dispatch => {
  switch (name) {
    case "i_region_fact":
      dispatch({ type: CLEAR_INDEX_AND_DISTRICT_FACT });
      dispatch({ type: APPLICANT_ADDRESS_CLEAR_FACT_REGION });
      dispatch({ type: REQUEST_SET_DISTRICT_FACT });
      axios
        .all([getDistrict(id), getIndex(id)])
        .then(
          axios.spread((district, index) => {
            dispatch(receiveDistrict_fact(district));
            dispatch(receiveIndex_fact(index));
          })
        )
        .catch(err => {
          dispatch({
            type: GET_ERRORS,
            payload: err
          });
          // Toast.fire({
          //   title: "Помилка сервера.",
          //   type: "error"
          // });
        });
      break;
    case "i_subdivision_fact":
      dispatch({ type: CLEAR_CITY_STREET_BANKS_FACT });
      dispatch({ type: REQUEST_SET_CITY_FACT });
      axios
        .all([getCity(id), getStreet(id), getBanks(id)])
        .then(
          axios.spread((city, street, banks) => {
            dispatch(receiveCity_fact(city));
            dispatch(receiveStreet_fact(street));
            dispatch(receiveBanks(banks));
          })
        )
        .catch(err => {
          dispatch({
            type: GET_ERRORS,
            payload: err
          });
          // Toast.fire({
          //   title: "Помилка сервера.",
          //   type: "error"
          // });
        });
      break;
  }
};
